var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-signature-pad',{attrs:{"id":"signature","save_type":"image/jpeg"},on:{"save":function($event){return _vm.save_click($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }